module.exports = __webpack_public_path__ + "img/pk.77777d90.svg";